import { render, staticRenderFns } from "./NewsListScreen.vue?vue&type=template&id=4db09b94"
import script from "./NewsListScreen.vue?vue&type=script&lang=ts"
export * from "./NewsListScreen.vue?vue&type=script&lang=ts"
import style0 from "./NewsListScreen.vue?vue&type=style&index=0&id=4db09b94&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports